export default "__VITE_ASSET__By40Rc0I__"